import { render, staticRenderFns } from "./EspecialidadPage.vue?vue&type=template&id=47938dea&scoped=true&"
import script from "./EspecialidadPage.vue?vue&type=script&lang=js&"
export * from "./EspecialidadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47938dea",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/EspecialidadPage.vue
// module id = 97
// module chunks = 2